// Axios
export interface AxiosErrorResponse {
  response?: {
    data?: {
      message?: string;
      msg?: string;
    };
  };
  message?: string;
}

export interface SignupProps {}

export interface ApiVerifyAccount {
  token: string;
  code: string;
}
export interface ApiResetPassword {
  email: string;
  code: string;
  password: string;
}

export interface PaginationDetails {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number;
  page: number;
  pages: number;
  prevPage: any;
  reads: number;
  totalDocs: number;
  unReads: number;
}
export const PaginationDetailsDummyData = {
  hasNextPage: false,
  hasPrevPage: false,
  nextPage: 1,
  page: 1,
  pages: 1,
  prevPage: null,
  reads: 0,
  totalDocs: 0,
  unReads: 0,
}